import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import ProdutoClienteService from "service/fiscal/ProdutoClienteService";
import { filterApplyTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const produtoClienteService = new ProdutoClienteService();

export default function ProdutoClienteListagem() {
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);

    useEffect(() => {
        produtoClienteService.produtos().then(setProdutos)
            .catch(error => console.error("Erro ao buscar produtos:", error));
        produtoClienteService.clientes().then(setClientes)
            .catch(error => console.error("Erro ao buscar clientes:", error));
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        produto: { constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }], operator: FilterOperator.AND },
        cliente: { constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }], operator: FilterOperator.AND },
        ufDestino: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        codigoProdutoCliente: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        cfop: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="id,ASC" service={produtoClienteService} urlService="/produtoCliente"
            tituloPagina="Produtos x Clientes" defaultFilters={defaultFilters} showClearFilterButton nome="produtoCliente">
            <Column field="produto.nome" header="Produto" filter filterField="produto" showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                filterElement={(options: ColumnFilterElementTemplateOptions) => (
                    <Dropdown value={options.value} options={produtos} optionLabel="nome" optionValue="codigo" filter showClear
                        onChange={(e) => options.filterCallback(e.value)} placeholder="Qualquer" className="p-column-filter" />
                )} />
            <Column field="cliente.nome" header="Cliente" filter filterField="cliente" showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                filterElement={(options: ColumnFilterElementTemplateOptions) => (
                    <Dropdown value={options.value} options={clientes} optionLabel="nome" optionValue="id" filter showClear
                        onChange={(e) => options.filterCallback(e.value)} placeholder="Qualquer" className="p-column-filter" />
                )} />
            <Column field="ufDestino" header="UF destino" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="codigoProdutoCliente" header="Código no cliente" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="cfop" header="CFOP" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativo" header="Ativo" body={(rowData) => rowData.ativo ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
